import styled from "styled-components";

const Wrapper = styled.div`
  padding-block: 20px;
  min-width: 290px;
  background: #22292f;
  position: -webkit-sticky;
  position: sticky;
  top: 73.48px;
  height: calc(100vh - 73px);
  overflow: auto;
`;

export default Wrapper;
